// const domain = "https://cvrs.slarenasitsolutions.com:8080/";

const domain = "https://dots-mern.onrender.com/";
// const domain = "http://localhost:8080/";

export default domain;
